define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var IntegrationsRowsCollection = require("manager-collections/data-sources/integrations/IntegrationsRowsCollection");

    var KEYS = {
        ID: "id",
        NAME: "name",
        SHOW: "show",
        ROWS: "rows",
        COLUMNS: "columns"
    };

    var IntegrationsCategoryModel = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        IntegrationsCategoryModel = BaseModel.extend({
            defaults: {
                "id": null,
                "name": "",
                "show": false,
                "columns": [],
                "rows": []
            },
            name: "IntegrationsCategoryModel",

            initialize: function (options) {
            },

            getId: function () {
                return this.get(KEYS.ID);
            },
            getShow: function () {
                return this.get(KEYS.SHOW);
            },
            setShow: function (show) {
                this.set(KEYS.SHOW, show);
            },
            getLogicalName: function () {
                return this.get(KEYS.NAME);
            },
            getName: function () {
                return LE.translator.translate('LEManager.dataSources.tab.integrations.category.' + this.getLogicalName() + ".title");
            },
            getColumns: function () {
                return this.get(KEYS.COLUMNS);
            },
            getDataSourcesRows: function () {
                return this.get(KEYS.ROWS);
            },
            getFirstColumnData: function () {
                var result = {};
                var first = this.getColumns().first;
                var name = first.name;
                name = _.isEmpty(name) ? "" : LE.translator.translate('LEManager.dataSources.tab.integrations.columns.' + name + ".title");
                var show = first.show;
                result.name = name;
                result.show = show;
                if (!_.isUndefined(first.width)){
                    result.width = first.width;
                }
                return result;
            },
            getSecondColumnData: function () {
                var result = {};
                var second = this.getColumns().second;
                var name = second.name;
                name = _.isEmpty(name) ? "" : LE.translator.translate('LEManager.dataSources.tab.integrations.columns.' + name + ".title");
                var show = second.show;
                result.name = name;
                result.show = show;
                if (!_.isUndefined(second.width)){
                    result.width = second.width;
                }
                return result;
            },
            getThirdColumnData: function () {
                var result = {};
                var third = this.getColumns().third;
                var name = third.name;
                name = _.isEmpty(name) ? "" : LE.translator.translate('LEManager.dataSources.tab.integrations.columns.' + name + ".title");
                var show = third.show;
                result.name = name;
                result.show = show;
                if (!_.isUndefined(third.width)){
                    result.width = third.width;
                }
                return result;
            },
            getRowsCollection: function () {
                if (_.isUndefined(this.dataSourcesRowsCollection)) {
                    this.dataSourcesRowsCollection = new IntegrationsRowsCollection(this.getDataSourcesRows());
                }
                return this.dataSourcesRowsCollection;
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    IntegrationsCategoryModel.KEYS = KEYS;

    return IntegrationsCategoryModel;
});
